import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";
import NoteCard from "@/Components/Cards/NoteCard";

const currentTheme = themes.morning;

function AvatarPhotoGuidelineCard(): React.JSX.Element {
  return (
    <View style={styles.container}>
      <View style={styles.sectionContainer}>
        <Text style={styles.sectionTitle}>🌈 Be Seen, Be Real</Text>
      </View>
      <NoteCard text="Upload photo of your face so people know who they're connecting with." />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: Spacings.s4,
    paddingHorizontal: Spacings.s4,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: Spacings.s2,
  },
  sectionTitle: {
    fontSize: currentTheme.typography.h2.size.mobile + 2,
    marginLeft: 5,
    fontWeight: "bold",
  },
});

export default AvatarPhotoGuidelineCard;
